import React from 'react';
import { ArrowRight, Heart, ChevronDown } from 'lucide-react';
export function HeroSectionCanino456() {
  return <section className="relative min-h-[90vh] flex items-center justify-center overflow-hidden pt-16 pb-20" style={{
    backgroundColor: '#F8F6F1'
  }} data-id="element-843">
      {/* Background blobs */}
      <div className="absolute top-0 left-0 w-[500px] h-[500px] rounded-full blur-[120px] -translate-y-1/3 -translate-x-1/4 opacity-15" style={{
      backgroundColor: '#2F5D50'
    }} data-id="element-844" />
      <div className="absolute bottom-0 right-0 w-[500px] h-[500px] rounded-full blur-[120px] translate-y-1/3 translate-x-1/4 opacity-10" style={{
      backgroundColor: '#C0392B'
    }} data-id="element-845" />

      <div className="container mx-auto px-4 relative z-10 max-w-3xl" data-id="element-846">
        {/* Emotional badge */}
        <div className="text-center mb-8" data-id="element-847">
          <div className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full border-2 shadow-lg" style={{
          backgroundColor: '#2F5D50',
          borderColor: '#1e4a3d'
        }} data-id="element-848">
            <Heart className="w-5 h-5 text-white fill-white" data-id="element-849" />
            <span className="text-sm font-bold tracking-wide uppercase text-white" data-id="element-850">
              Un mensaje para ti
            </span>
          </div>
        </div>

        {/* Main heading */}
        <h1 className="text-3xl md:text-5xl font-extrabold text-center mb-10 leading-tight" style={{
        color: '#2F5D50'
      }} data-id="element-851">
          Imagina el silencio en la casa el día que tu perro{' '}
          <span style={{
          color: '#C0392B'
        }} data-id="element-852">
            ya no esté…
          </span>
        </h1>

        {/* Emotional lines */}
        <div className="max-w-lg mx-auto space-y-4 mb-10" data-id="element-853">
          {['Sin sus pasos.', 'Sin su cola moviéndose cuando llegas.', 'Sin ese compañero que siempre estaba contigo.'].map((line, i) => <p key={i} className="text-lg md:text-xl text-gray-600 text-center font-medium italic" data-id="element-854">
              {line}
            </p>)}
        </div>

        {/* Explanation */}
        <div className="bg-white border-2 rounded-2xl p-6 md:p-8 shadow-md mb-10 relative overflow-hidden" style={{
        borderColor: '#6DAA7F'
      }} data-id="element-855">
          <div className="absolute top-0 right-0 w-24 h-24 rounded-full blur-2xl opacity-20 -translate-y-1/2 translate-x-1/2" style={{
          backgroundColor: '#6DAA7F'
        }} data-id="element-856" />
          <p className="text-base md:text-lg text-gray-700 leading-relaxed relative z-10 mb-4" data-id="element-857">
            Muchos perros desarrollan enfermedades digestivas y alergias{' '}
            <span className="font-bold" style={{
            color: '#C0392B'
          }} data-id="element-858">
              años antes de que los dueños lo noten.
            </span>
          </p>
          <p className="text-base md:text-lg text-gray-700 leading-relaxed relative z-10 mb-4" data-id="element-859">
            Y una de las principales causas es la{' '}
            <span className="text-white px-2 py-0.5 rounded-md font-bold text-sm" style={{
            backgroundColor: '#C0392B'
          }} data-id="element-860">
              inflamación provocada por la alimentación diaria.
            </span>
          </p>
          <p className="text-base md:text-lg text-gray-700 leading-relaxed relative z-10" data-id="element-861">
            Por eso creamos esta guía con{' '}
            <span className="font-bold" style={{
            color: '#2F5D50'
          }} data-id="element-862">
              30 recetas naturales diseñadas para proteger su salud desde
              adentro.
            </span>
          </p>
        </div>

        {/* CTA */}
        <div className="text-center" data-id="element-863">
          <div className="flex items-center justify-center gap-2 mb-6" data-id="element-864">
            <ChevronDown className="w-5 h-5 animate-bounce" style={{
            color: '#F57C00'
          }} data-id="element-865" />
            <p className="text-lg font-bold" style={{
            color: '#F57C00'
          }} data-id="element-866">
              👇
            </p>
            <ChevronDown className="w-5 h-5 animate-bounce" style={{
            color: '#F57C00'
          }} data-id="element-867" />
          </div>

          <button onClick={() => {
          const section = document.getElementById('pattern-section');
          if (section) {
            section.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
          }
        }} className="group relative text-white text-lg md:text-xl font-bold py-5 px-10 rounded-2xl shadow-xl transition-all duration-300 hover:-translate-y-1 hover:shadow-2xl flex items-center gap-3 mx-auto overflow-hidden text-center leading-tight" style={{
          background: 'linear-gradient(to right, #F57C00, #e07000)',
          boxShadow: '0 10px 30px rgba(245,124,0,0.35)'
        }} onMouseEnter={e => e.currentTarget.style.background = 'linear-gradient(to right, #E66A00, #cc5f00)'} onMouseLeave={e => e.currentTarget.style.background = 'linear-gradient(to right, #F57C00, #e07000)'} data-id="element-868">
            <span className="relative z-10 flex items-center gap-3" data-id="element-869">
              QUIERO CUIDAR LA SALUD DE MI PERRO
              <ArrowRight className="w-6 h-6 group-hover:translate-x-1 transition-transform hidden md:block" strokeWidth={3} data-id="element-870" />
            </span>
            <div className="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300 skew-y-12" data-id="element-871" />
          </button>
        </div>
      </div>
    </section>;
}